import React from 'react';
import { Box } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

interface SkeletonLoadersProps {
  loaders: Array<{
    width: string;
    height?: string;
    marginLeft?: string;
    marginRight?: string;
    isCenterAligned?: boolean;
    circle?: boolean;
  }>;
  boxStyles?: Record<string, unknown>;
  useSingleWrapper?: boolean;
  testId?: string;
  isLoadersCenterAligned?: boolean;
}

export const SkeletonLoaders: React.FC<SkeletonLoadersProps> = ({
  loaders,
  boxStyles,
  useSingleWrapper,
  testId,
  isLoadersCenterAligned = true,
}) => (
  <Box style={boxStyles} testId={testId}>
    {useSingleWrapper ? (
      <SkeletonLoaderWrapper>
        {loaders.map((loader, index) => (
          <SkeletonLoader key={index} isCenterAligned={isLoadersCenterAligned} {...loader} />
        ))}
      </SkeletonLoaderWrapper>
    ) : (
      loaders.map((loader, index) => (
        <SkeletonLoaderWrapper key={index}>
          <SkeletonLoader isCenterAligned={isLoadersCenterAligned} {...loader} />
        </SkeletonLoaderWrapper>
      ))
    )}
  </Box>
);
